// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class MedicalEligibilitySecondaryInsurance {
    'exists'?: boolean | null;
    'name'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof MedicalEligibilitySecondaryInsurance>> = [
        {
            "name":     "exists",
            "baseName": "exists",
            "type":     "boolean"
        },
        {
            "name":     "name",
            "baseName": "name",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return MedicalEligibilitySecondaryInsurance.attributeTypeMap;
    }
}
